(function() {
    'use strict';

a3_pilot_reports.directive('groundCrew',groundCrew);
    
    
 /**
   * @memberof PilotReports
   * @ngdoc directive
   * @name groundCrew
   * @restrict E
   * @description
   * Initialize Trainer and Trainee Info
   * @example
   *   Usage:
   *   <ground-crew></ground-crew>
   * @ngInject 
   */      
function groundCrew () {
    function link(scope, element, attrs){
        scope.groundDuty = scope.duty;
        scope.toggleCrewList = toggleCrewList

        scope.groundDuty.Trainees.forEach(function(relatedTrainees){
            relatedTrainees.isCollapsed = false;
            relatedTrainees.dynamicSize = 10;
        });

        /**
         * @memberof GroundDutyCtrl
         * @name toggleCrewList
         * @description 
         * Οnly show the first 10 trainees - if more then toggle
         */
        function toggleCrewList(relatedTrainees){
            relatedTrainees.isCollapsed = !relatedTrainees.isCollapsed;

            if(relatedTrainees.isCollapsed) relatedTrainees.dynamicSize = relatedTrainees.CrewMembers.length;
            else relatedTrainees.dynamicSize = 10;
        }

    }
		return {
			restrict: 'E',
			terminal: true,
			templateUrl: "views/directives/groundCrew.tpl.html",
			scope : {
                duty: '='
            },
            link: link
		}
	} 

})();
